<template>
  <div>
    <template v-if="loading">{{ $t('voc.loading') }}</template>
    <template v-if="!loading && sideBarOpened">
      <div class="adp-side-card-wrap">
        <div class="d-flex flex-column adp-side-card">
          <span class="adp-h2">{{ employee.fullname }}</span>
          <span class="adp-p">{{ employee.pernumber }}</span>
          <span class="adp-p">{{ employee.position }}</span>
        </div>
      </div>

      <template v-if="managers.length">
        <div class="adp-subtitle">
          <span class="adp-h2">{{ $t(`voc.managers`) }}</span>
        </div>
        <div :title="manager.fullname" v-for="(manager, i) in managers">
          <div class="adp-flex-row adp-filter-list-item">
            <div class="adp-filter-list-item-emp adp-flex-column">
                <span class="adp-p adp-p__bold">
                  {{ manager.fullname.length > 40 ? manager.fullname.substr(0, 40) + '...' : manager.fullname }}
                </span>
              <span class="adp-p adp-p__grey">{{ manager.email }}</span>
              <span class="adp-p adp-p__grey">{{ manager.phone }}</span>
            </div>
          </div>
        </div>
      </template>
      <div style="border-bottom: 1px solid #CCCCCC;" v-else>
        <div class="adp-subtitle"><span class="adp-h2">{{ $t(`voc.managers`) }}</span></div>
        <div style="padding-left: 24px; margin: 25px 0 20px 0">{{ $t(`voc.managers_empty`) }}</div>
      </div>

      <template v-if="functionalManagers.length">
        <div class="adp-subtitle">
          <span class="adp-h2">{{ $t(`voc.functional_managers`) }}</span>
        </div>
        <div :title="fManager.fullname" v-for="(fManager, i) in functionalManagers">
          <div class="adp-flex-row adp-filter-list-item">
            <div class="adp-filter-list-item-emp adp-flex-column">
                <span class="adp-p adp-p__bold">
                  {{ fManager.fullname.length > 40 ? fManager.fullname.substr(0, 40) + '...' : fManager.fullname }}
                </span>
              <span class="adp-p adp-p__grey">{{ fManager.email }}</span>
              <span class="adp-p adp-p__grey">{{ fManager.phone }}</span>
            </div>
          </div>
        </div>
      </template>
      <div style="border-bottom: 1px solid #CCCCCC;" v-else>
        <div class="adp-subtitle"><span class="adp-h2">{{ $t(`voc.functional_managers`) }}</span></div>
        <div style="padding-left: 24px; margin: 25px 0 20px 0">{{ $t(`voc.functional_managers_empty`) }}</div>
      </div>
    </template>

    <div class="adp-sidebar-close adp-sidebar-close__employee" v-if="sideBarOpened" @click="closeSidebar">
      <span class="adp-sidebar-close__text">
        {{ $t('voc.table_close_sidebar_employee') }}
      </span>
      <span class="adp-sidebar-close__icon">
        <img src="/images/sidebar-close.svg" style="position: absolute;right: 7px;top: -1px;">
        <img src="/images/sidebar-close.svg">
      </span>
    </div>

    <div class="adp-sidebar-open" v-if="!sideBarOpened" @click="openSidebar">
      <div class="adp-sidebar-open__icon">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 18px; top: 17px;">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 25px; top: 17px;">
      </div>
      <div class="adp-sidebar-open__text" style="padding: 15px; white-space: nowrap;">{{ $t('voc.table_open_sidebar_employee') }}</div>
    </div>

  </div>
</template>

<script>
import api from "../api";

export default {
  name: "EmployeeSidebar",
  data: function () {
    return {
      sideBarOpened: false,
      loading: true,
      employee: {},
      managers: [],
      functionalManagers: [],
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        let res = await api.getEmployeeSidebar();
        this.employee = res.data.employee;
        this.managers = res.data.managers;
        this.functionalManagers = res.data.functional_managers;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    closeSidebar() {
      this.sideBarOpened = false;
      this.$emit('close-sidebar');
    },
    openSidebar() {
      this.sideBarOpened = true;
      this.$emit('open-sidebar');
    },
  },
  mounted() {
    this.getData();
  }
}
</script>
